import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";
import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";

const HospitalPharmacyIntegrationBlog = () => {
  return (
    <div className="min-h-screen w-full font-sans overflow-x-hidden bg-[#d2e5e4] text-black px-4 py-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Main Blog */}
        <div className="flex-1">
          <img
            src={image5}
            alt="Hospital Pharmacy Integration"
            className="w-full h-72 object-cover bg-gray-100 border border-gray-300 rounded-lg mb-6"
          />

          <div className="bg-sky-700 text-white text-3xl font-bold py-4 px-6 rounded mb-8">
            Discover how AI-powered hospital management systems like MedOps
            reduce paperwork, improve staff efficiency, and enable data-driven
            decisions
          </div>

          <div className="space-y-8 text-lg text-black">
            <div>
              <h2 className="text-xl font-semibold mb-2">Introduction</h2>
              <p>
                Artificial Intelligence (AI) is no longer a futuristic concept
                in healthcare—it is happening right now. From reducing manual
                paperwork to assisting doctors in decision-making, AI-driven
                systems like
                <strong> MedOps </strong> are reshaping how hospitals function.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                📑 AI Reduces Paperwork and Errors
              </h2>
              <p>
                Traditional hospitals spend hours handling patient records
                manually. With AI-powered hospital management systems, medical
                history, lab reports, and prescriptions are digitized, saving
                valuable time. This reduces human errors and ensures instant
                data retrieval.
              </p>
              <p className="mt-2 italic">
                Example: A mid-sized hospital using MedOps reduced patient
                waiting time by 40% after switching to digital patient records.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🏥 Smart Scheduling for Staff Efficiency
              </h2>
              <p>
                Hospital staff often face workload imbalances. AI algorithms in
                MedOps analyze staff availability, patient load, and department
                needs to create optimized duty rosters, preventing burnout and
                improving care quality.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                💊 Pharmacy and Inventory Automation
              </h2>
              <p>
                AI ensures pharmacy stock levels are monitored in real time.
                Expiry alerts, low-stock notifications, and automated purchase
                requests prevent shortages while saving costs.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                📊 Predictive Analytics for Better Decisions
              </h2>
              <p>
                Hospital administrators can use AI-powered dashboards to
                forecast patient inflow, seasonal disease trends, and even ICU
                bed requirements. Data-driven decision-making helps hospitals
                stay prepared.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">Conclusion</h2>
              <p>
                AI is not here to replace doctors—it’s here to make them more
                effective. With <strong>MedOps</strong>, hospitals can achieve{" "}
                <em>One Platform. Total Hospital Automation.</em>
              </p>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full md:w-1/3 border-t md:border-t-0 md:border-l border-gray-700 pt-10 md:pt-0 md:pl-8">
          <h3 className="text-xl font-semibold mb-6">Recent Blogs</h3>

          {[
            {
              image: image201,
              alt: "PredictiveAnalyticsBlog",
              to: "/predictiveanalyticsblog",
              title: " Learn more about Predictive Analytics ",
            },
            {
              to: "/inpatientoutpatientblog",
              alt: "InPatient and OutPatient Blog",
              title:
                "  Explore how MedOps integrates with ABHA IDs, digital health missions, and AI automation to build the future of Indian healthcare",
              image: image2,
            },
            {
              to: "/voiceprescriptionblog",
              alt: "Voice Prescription Blog",
              title:
                "Learn how MedOps uses AI for real-time monitoring, cloud-based records, and decision support to enhance patient care",
              image: image1,
            },
            {
              image: image203,
              alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
              to: "/cuttingdownpatientreportdeliverytimewithaiblog",
              title:
                "Learn more about Cutting Down Patient Report Delivery Time with AI",
            },
            {
              to: "/inventorytrackingblog",
              alt: "Inventory Tracking Blog",
              title:
                "Real-Time Inventory Tracking with MedOps: Smarter Stock, Smarter Care",
              image: image6,
            },
            {
              to: "/diagnosticlabintegrationblog",
              alt: "Diagnostic Lab Integration Blog",
              title:
                "AI-Powered Diagnostic Report Generation & Lab Integration",
              image: image4,
            },
            {
              to: "/advancedanalyticscampaignblog",
              alt: "Advanced Analytics Blog",
              title: "Advanced Analytics & Campaign Management",
              image: image3,
            },
            {
              image: image202,
              alt: "BestHMSforYourHospitalBlog",
              to: "/besthmsforyourhospitalblog",
              title: "Learn more about Best HMS for Your Hospital ",
            },
                 {
                                      image: image204,
                                      alt: "MedicineForecastingBlog",
                                      to: "/medicineforecastingblog",
                                      title: " Learn more about Medicine Forecasting ",
                                    },
          ].map((blog, idx) => (
            <div key={idx} className="mb-6">
              <Link
                to={blog.to}
                className="flex flex-col gap-2 hover:opacity-90"
              >
                <img
                  src={blog.image}
                  alt={blog.alt}
                  className="w-full h-54 object-cover bg-gray-100 border border-gray-300 rounded"
                />
                <span className="text-sky-600 font-semibold text-sm">
                  {blog.title}
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HospitalPharmacyIntegrationBlog;
